import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import MapDisplay from "@components/MapDisplay.tsx";
// ;

const MapTest: React.FC = () => {
  const [testCoordinates] = useState({
    lat: 55.7558,
    lng: 37.6176,
    label: 'Moscow, Red Square'
  });

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Map Provider Test
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Test Coordinates: {testCoordinates.lat}, {testCoordinates.lng}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          This map will automatically switch between Yandex Maps and 2GIS based on your settings.
          Go to Settings → Application → Map Provider to change the provider.
        </Typography>
      </Paper>

      <MapDisplay 
        lat={testCoordinates.lat} 
        lng={testCoordinates.lng} 
        label={testCoordinates.label} 
      />
    </Box>
  );
};

export default MapTest; 